import React, { useState, useEffect } from 'react';
import Button from '../../../partials/Button'
import InterveneFeedback from './intervene-feedback/InterveneFeedback'

const Feedback = (props) => {
    let [feedback, setFeedback] = useState(props.intervenArray || { "correct": [], "wrong": [], "missed": [] })
    console.log(feedback.correct.length)

    const headerStyle = { fontSize: "18px", fontWeight: "bold" }
    return (
        <div>
            <div style={{ color: "white", backgroundColor: "#283044", height: "498px", padding: "25px", fontFamily: "Rajdhani", overflow: "auto", marginTop: "127px" }}>
                {(feedback.correct.length > 0) &&
                    <div>
                        <h3 style={headerStyle}>Correct</h3>
                        {feedback.correct.map(x => {
                            return (
                                <div>
                                    <InterveneFeedback
                                        name={x.name}
                                        dialogue={x.dialogue}
                                        feedback={x.feedback}
                                        img={x.image} />
                                </div>
                            )
                        })}
                    </div>
                }
                {(feedback.wrong.length > 0 || feedback.missed.length > 0) &&
                    <div>
                        <h3 style={headerStyle}>Wrong/ Missed</h3>
                        {feedback.wrong.map(x => {
                            return (
                                <div>
                                    <InterveneFeedback
                                        name={x.name}
                                        dialogue={x.dialogue}
                                        feedback={x.feedback}
                                        img={x.image} />
                                </div>
                            )
                        })}

                        {feedback.missed.map(x => {
                            return (
                                <div>
                                    <InterveneFeedback
                                        name={x.name}
                                        dialogue={x.dialogue}
                                        feedback={x.feedback}
                                        img={x.image} />
                                </div>
                            )
                        })}
                    </div>
                }
            </div>
            <div style={{ position: "relative", left: "490px", top: "3px" }}>
                <Button text="Take Quiz" onClick={props.quizClick && props.quizClick} />
            </div>

        </div>

    )
}

export default Feedback;